const planning = {
  id: "planning",
  title: "Planning Process & Timeline Structure",
  questions: [
    {
      question: "What is your standard planning process from inquiry to execution?",
      answer: "We follow a structured flow: Requirement Understanding → Concept Proposal → Budget Approval → Vendor Confirmation → Pre-Event Recce → Final Execution → Post-Event Report."
    },
    {
      question: "How soon do you share the initial proposal?",
      answer: "Concept outlines are typically shared within 24–48 hours of receiving complete requirements."
    },
    {
      question: "When do detailed itineraries or event flow documents get finalized?",
      answer: "Detailed documents are shared after confirmation and refined through scheduled planning calls."
    },
    {
      question: "Do you conduct pre-event site inspections?",
      answer: "Yes. Venue recce and technical checks are conducted to eliminate on-ground uncertainties."
    },
    {
      question: "How do you manage planning timelines for large-scale events?",
      answer: "We work with milestone-based planning charts covering approvals, production, logistics, and guest communication."
    },
    {
      question: "How often do you provide progress updates before the event?",
      answer: "Regular update calls and status reports are shared as per the agreed planning schedule."
    },
    {
      question: "What happens if the event date is very close?",
      answer: "We activate an accelerated planning model with parallel vendor confirmations and rapid execution timelines."
    },
    {
      question: "Do you coordinate directly with our internal teams?",
      answer: "Yes. We align closely with your HR, marketing, admin, or procurement teams for seamless approvals."
    },
    {
      question: "How do you ensure nothing is missed before execution day?",
      answer: "We operate with detailed SOP checklists and final run-through meetings prior to event launch."
    },
    {
      question: "Do you provide a post-event closure process?",
      answer: "Yes. We conduct financial reconciliation, feedback analysis, and performance reporting after completion."
    }
  ]
};

export default planning;
